var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "self-serve-loading-screen" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          "is-full-page": false,
          loader: "dots",
          color: "#1A74DB",
          height: "45",
          width: "100%",
          opacity: "0",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "loading-text loading-body" }, [
        _c(
          "span",
          [
            _vm._v("\n            We are taking a few seconds to "),
            _c("br"),
            _vm._v("assemble your shopping experience."),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _vm.smallFleetMessaging
              ? [
                  _vm._v("Want to shop later? Check your email inbox "),
                  _c("br"),
                  _vm._v("for a link to return to the webstore."),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-text loading-title" }, [
      _c("span", [_vm._v("Hold on tight")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }